import styled from 'styled-components';
import { H1, SectionParent } from '../../../components/StyledComponents';

import React from 'react';
import lottie, { AnimationItem } from 'lottie-web';

const SectionOne = styled(SectionParent)`
  background-repeat: no-repeat;
  background-color: #ffffff;
  padding-top: 3rem !important;
  padding-bottom: 2rem !important;
  background-size: contain;
  @media (max-width: 768px) {
    padding-top: 3rem !important;
    padding-bottom: 2rem !important;
  }
  @media (max-width: 520px) {
    padding-top: 0rem !important;
  }
  width: 100%;
  display: grid;
`;

const SectionItemContainer = styled.div`
  grid-template-columns: repeat(3, 1fr);
  padding-left: 5rem;
  display: grid;
  @media (max-width: 768px) {
    padding-left: 0rem;
  }
`;

const HeroTitle = styled(H1)`
  margin-left: 2.5rem;
  color: #151828;
  font-family: 'Nunito Sans', sans-serif;
  font-weight: bold;
  text-align: center;
  @media (min-width: 1440px) {
    font-size: 28px !important;
  }
  @media (max-width: 768px) {
    margin-left: 0rem;
    text-align: center;
  }
  @media (max-width: 350px) {
    font-size: 18px;
  }
`;

const GridRight = styled.div`
  grid-column: span 3;
  padding-right: 8rem;
  /* padding-left: 3rem; */
  margin-top: 3rem;
  align-content: center;
  display: grid;
  @media (max-width: 1100px) {
    margin-top: 7rem;
  }
  @media (max-width: 768px) {
    grid-column: span 3;
    padding-right: 0rem;
    margin-top: 0rem;
    padding-left: 0rem;
    min-height: unset;
  }
  @media (max-width: 520px) {
    min-height: unset;
    padding: 3rem 0;
  }
`;
const GridLeft = styled.div`
  grid-column: span 3;
  /* padding-left: 7rem; */
  width: 100%;
  justify-self: center;
  position: relative;
  @media (max-width: 1100px) {
    padding-left: 0;
  }
  @media (max-width: 768px) {
    grid-column: span 3;
    padding-left: 0;
    width: 100%;
    /* max-width: 15rem; */
    justify-self: center;
  }
  @media (max-width: 520px) {
    padding-left: 0;
    margin-top: -2rem;
  }
`;

const HeroSubTitle = styled.div`
  padding-top: 2rem;
  margin-left: 3rem;
  font-family: 'Nunito Sans', sans-serif;
  font-size: 16px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.64;
  letter-spacing: normal;
  color: #ffffff;
  @media (max-width: 768px) {
    text-align: center;
    margin-left: 0rem;
  }

  @media (max-width: 520px) {
    text-align: center;
    padding-top: 0.5rem;
    margin-bottom: -1rem;
    margin-left: 0;
  }
`;

export default class KioskSecondPage extends React.Component<any, any> {
  animation?: AnimationItem;
  isCMounted = true;

  constructor(props: any) {
    super(props);
    this.animation = undefined;
  }

  scrollFunction = () => {
    // Get the header
    const header = document.getElementById('section-one-kiosk');

    if (header && this.isCMounted) {
      // Get the offset position of the navbar
      const containerTop = header!.offsetTop;
      // const containerBottom = header!.offsetTop + header!.clientHeight;
      const currentBottomPosition = window.pageYOffset + window.innerHeight;
      const currentTopPosition = window.pageYOffset;
      if (
        currentBottomPosition > containerTop &&
        currentTopPosition < containerTop
      ) {
        // lottie.play('animation-kiosk')
        const scrollPercent = (45 * currentTopPosition) / containerTop;
        const scrollRounded = Math.round(scrollPercent);
        this.animation!.goToAndStop(scrollRounded, true);
      } else {
        this.animation!.goToAndStop(45, true);
      }
    }
  };

  componentWillUnmount() {
    this.isCMounted = false;
  }
  componentDidMount() {
    this.isCMounted = true;
    window.onscroll = this.scrollFunction;
    this.animation = lottie.loadAnimation({
      name: 'animation-kiosk',
      container: document.getElementById('lottie-animation-kiosk')!,
      loop: true,
      renderer: 'svg',
      autoplay: true,
      animationData: require('../../lottieAnimations/Develop_Deploy_Manage.json'),
    });
  }

  render() {
    return (
      <div>
        <SectionOne id="section-one-kiosk">
          <SectionItemContainer>
            <GridRight>
              <HeroTitle>
                The Leading Platform for Digital <br />
                Signage Solution Builders
              </HeroTitle>
            </GridRight>
            <GridLeft id="lottie-animation-kiosk" />
          </SectionItemContainer>
        </SectionOne>
      </div>
    );
  }
}
